/**
 * Predicate for live (socket-driven) React Query invalidation of World Cup
 * squad/group leaderboards.
 *
 * Squad leaderboard query keys are shaped:
 *   ['worldcup', competitionId, 'groups', groupId, 'leaderboard', ...]
 * which covers both the regular squad leaderboard and TV mode (a 'tv' segment
 * follows 'leaderboard'). The match:update handler uses this to refresh squad
 * standings live; without it they only refresh on a staleTime-expiry remount,
 * so they don't move during or right after a match.
 *
 * It must NOT match the global WC leaderboard (['worldcup', id, 'leaderboard'])
 * nor the squad list / member / matches keys.
 */
export function isWorldCupGroupLeaderboardQueryKey(
  queryKey: readonly unknown[],
): boolean {
  return (
    queryKey[0] === 'worldcup'
    && queryKey[2] === 'groups'
    && queryKey[4] === 'leaderboard'
  );
}
